import { render, staticRenderFns } from "./centurion-travel.vue?vue&type=template&id=60adc595&scoped=true&"
import script from "./centurion-travel.vue?vue&type=script&lang=js&"
export * from "./centurion-travel.vue?vue&type=script&lang=js&"
import style0 from "./centurion-travel.vue?vue&type=style&index=0&id=60adc595&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60adc595",
  null
  
)

export default component.exports